import { get, post } from '../../lib/actionHelpers.js';
import { store } from 'redux/lib/configureStore.js';
import selectors from 'selectors/selectors.js';

export const getCombinedMessages = ({ serviceProviderId, uid, readOrUnread, count, folder, serviceLocationId, eventId, locationId, eventType, isUnique, outgoing, offset }, callback) => {
  let action = offset !== 0 ? 'GET_PAGINATED_MESSAGES_FOR_INBOX' : 'GET_MESSAGES_FOR_INBOX';
  const statusIds = folder.statusIds || [];
  if (eventId && eventType) {
    action = 'GET_MESSAGE_FOR_INBOX';
  }
  if (count) {
    action = 'GET_MESSAGE_COUNTS_FOR_INBOX';
  }

  const leads = folder.leads === true;
  const nonLeads = folder.nonLeads === true;
  let payload = {
    offset: offset,
    event_user_id: !folder.excludeUser && uid !== 'all' ? uid : undefined,
    read_unread: readOrUnread === 'read' ? '1' : '0',
    event_id: eventId,
    leads: leads && !nonLeads ? '1' : nonLeads && !leads ? '0' : undefined,
    event_type: eventType,
    is_unique: isUnique,
    outgoing: outgoing,
    as_total: count ? '1' : undefined,
    form_type: folder.formType || undefined,
    status_ids: statusIds.length > 0 ? statusIds.join(',') : undefined,
    service_location_id: locationId || (serviceLocationId !== 'all' ? serviceLocationId : undefined),
    report_order: folder.sort || 'desc',
    tag: folder.id,
  };
  Object.keys(payload).forEach((key) => (payload[key] === undefined ? delete payload[key] : {}));

  if (eventId && eventType) {
    payload = {
      event_id: eventId,
      event_type:
        {
          texts: 'Text',
          emails: 'Email',
          phone_calls: 'Call',
          web_forms: 'Form',
        }[eventType] || eventType,
    };
  }

  return get(`/service-provider/provider/${serviceProviderId}/communications-log`, {
    query: payload,
    action,
    meta: { folderId: folder.id },
    callback,
  });
};

export const getNonLeadMessage = ({ serviceProviderId, eventId, eventType }, callback) => {
  return get(`/event/${eventId}`, {
    query: {
      service_provider_id: serviceProviderId,
      event_type: eventType,
    },
    action: 'GET_MESSAGE_FOR_CHAT_LEADS',
    callback,
  });
};

export const getCommunicationLogs = ({ offset }, callback) => {
  const state = store.getState();
  const serviceProviderId = selectors.selectServiceProviderFromURL(state);
  const filters = selectors.filters(state);
  const action = offset ? 'GET_PAGINATED_MESSAGES_FOR_COMMUNICATION_LOGS' : 'GET_MESSAGES_FOR_COMMUNICATION_LOGS';
  return get(`/service-provider/provider/${serviceProviderId}/communications-log`, {
    query: {
      offset,
      event_user_id: filters.userId || undefined,
      event_type: filters.communicationType || undefined,
      leads: filters.leads || undefined,
      read_unread: filters.readOrUnread || undefined,
      is_unique: filters.isUnique || undefined,
      outgoing: filters.messageDirection || undefined,
      service_location_id: filters.locationId || undefined,
      form_type: filters.form_type || undefined,
    },
    action,
    callback,
  });
};

export const publishAction = ({ data, action = 'IGNORE_ACTION' }) => {
  const state = store.getState();
  const serviceProviderId = selectors.serviceProviderId(state);
  if (localStorage.getItem('token') && serviceProviderId) {
    return post(`/provider/${serviceProviderId}/publish`, {
      data: { ...data },
      action: action,
      callback: () => {},
    });
  }
};
